import React from "react";
import "../Customer.css";

// components imports
//
import { updateUser } from "../../../../store/userSlice";
import { showSnackBar } from "../../../../store/common/snackBarSlice";
import Loader from "../../../../Components/CircularLoader/CircularLoader";
// apis imports
import {
  getProfileData,
  updateProfileData,
  updateProfilePassword,
} from "../../../../services/settings.services";
import Countries from "../../../../data/countries";
// library imports
import { useSelector, useDispatch } from "react-redux";
import { Button, Container } from "react-bootstrap";
import Avatar from "react-avatar";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { BsPencil } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { useFormat } from "../../../../i18n/format";
import Skeleton from "@mui/material/Skeleton";

const Profile = () => {
  const { t } = useTranslation("settings");
  const { formatCountry } = useFormat();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);

  const [changed2, setchanged2] = useState(false);
  const [changed5, setchanged5] = useState(false);
  const [changed3, setchanged3] = useState(false);
  const [changed4, setchanged4] = useState(false);

  const [Profile, setProfile] = useState({});
  const [Profile2, setProfile2] = useState({});
  const [image, setimage] = useState(false);
  const [file, setfile] = useState(null);
  const [old_password, setold_password] = useState("");
  const [new_password, setnew_password] = useState("");
  const [con_password, setcon_password] = useState("");
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [showAdditionalWarehouseInfo, setShowAdditionalWarehouseInfo] =
    useState(false);
  const [showPasswordFields, setShowPasswordFields] = useState(false);

  const handleprofileimg = (e) => {
    setfile(e.target.files[0]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setProfile({ ...Profile, [name]: value });
  };

  const handleChangeForWarehouse = (e) => {
    const { name, value } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      warehouse: {
        ...prevProfile.warehouse,
        [name]: value,
      },
    }));
  };

  const handlenewpassword = (e) => {
    setnew_password(e.target.value);
  };

  const handleconpassword = (e) => {
    setcon_password(e.target.value);
  };

  const handleoldpassword = (e) => {
    setold_password(e.target.value);
  };

  const additionalInfoListClick = () => {
    setShowAdditionalInfo(!showAdditionalInfo);
  };

  const additionalWarehouseInfoListClick = () => {
    setShowAdditionalWarehouseInfo(!showAdditionalWarehouseInfo);
  };

  const handlePasswordEdit = () => {
    setShowPasswordFields(!showPasswordFields);
  };

  const handlepassword = async (event) => {
    event.preventDefault();
    try {
      setLoading("updatepassword");
      const payload = {
        old_password: old_password,
        new_password: new_password,
      };
      const response = await updateProfilePassword(payload);
      if (response.data.success === true) {
        setold_password("");
        setcon_password("");
        setnew_password("");
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "success",
          })
        );
        setLoading(false);
      } else {
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "error",
          })
        );
        setLoading(false);
      }
    } catch (error) {
      dispatch(
        showSnackBar({
          text: error?.response?.data?.message,
          severity: "error",
        })
      );
      setLoading(false);
    }
    setShowPasswordFields(!showPasswordFields);
  };

  const handleadditionalinfo = async (event) => {
    event.preventDefault();
    try {
      setLoading("additionalInfo");

      const response = await updateProfileData({
        firstname: Profile["firstname"],
        lastname: Profile["lastname"],
        business_name: Profile["business_name"],
        industry_type: Profile["industry_type"],
        experience: Profile["experience"],
        phone_number: Profile["phone_number"],
        website: Profile["website"],
        address: Profile["address"],
        country: Profile["country"],
        province: Profile["province"],
        city: Profile["city"],
        zip: Profile["zip"],
      });
      if (response.data.success === true) {
        setProfile(response.data.result);
        setProfile2(response.data.result);
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "success",
          })
        );
        setLoading(false);
      } else {
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "error",
          })
        );
        setLoading(false);
      }
    } catch (error) {
      dispatch(
        showSnackBar({
          text: error?.response?.data?.message,
          severity: "error",
        })
      );
      setLoading(false);
    }
    setShowAdditionalInfo(!showAdditionalInfo);
  };

  const handleWarehouseInfo = async (event) => {
    event.preventDefault();
    try {
      setLoading("warehouseInfo");

      const response = await updateProfileData({
        warehouse: {
          name: Profile?.warehouse?.["name"],
          country: Profile?.warehouse?.["country"],
          state: Profile?.warehouse?.["state"],
          city: Profile?.warehouse?.["city"],
          postcode: Profile?.warehouse?.["postcode"],
          address: Profile?.warehouse?.["address"],
        },
      });
      if (response.data.success === true) {
        setProfile(response.data.result);
        setProfile2(response.data.result);
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "success",
          })
        );
        setLoading(false);
      } else {
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "error",
          })
        );
        setLoading(false);
      }
    } catch (error) {
      dispatch(
        showSnackBar({
          text: error?.response?.data?.message,
          severity: "error",
        })
      );
      setLoading(false);
    }
    setShowAdditionalWarehouseInfo(!showAdditionalWarehouseInfo);
  };

  const handleimageupdate = async (event) => {
    event.preventDefault();

    setLoading("image");
    const formData = new FormData();
    formData.append("profile_image", file);
    try {
      const response = await updateProfileData(formData);
      if (response.data.success === true) {
        setProfile(response.data.result);
        setProfile2(response.data.result);
        localStorage.setItem(
          "profile_image",
          response.data.result.profile_image
        );
        localStorage.setItem(
          "user",
          JSON.stringify({
            ...user,
            profile_image: response.data.result.profile_image,
          })
        );
        dispatch(
          updateUser({
            ...user,
            profile_image: response?.data?.result?.profile_image,
          })
        );
        setimage(false);
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "success",
          })
        );
        setLoading(false);
        setfile(null);
      } else {
        dispatch(
          showSnackBar({
            text: response?.data?.message,
            severity: "error",
          })
        );
        setLoading(false);
      }
    } catch (error) {
      dispatch(
        showSnackBar({
          text: error?.response?.data?.message,
          severity: "error",
        })
      );
    }
  };

  useEffect(() => {
    // setProfile(user);
    const getProfile = async () => {
      setSkeletonLoading(true);
      try {
        const response = await getProfileData();

        if (response.data.success === true) {
          setSkeletonLoading(false);
          setProfile(response.data.result);
          setProfile2(response.data.result);
        }
      } catch (error) {
        setSkeletonLoading(false);
        dispatch(
          showSnackBar({
            text: error?.response?.data?.message,
            severity: "error",
          })
        );
      }
    };
    getProfile();
  }, []);

  useEffect(() => {
    // section 2
    let hasChanges2 = false;
    if (
      Profile2?.firstname != Profile.firstname ||
      Profile2?.lastname != Profile.lastname ||
      Profile2?.business_name != Profile.business_name ||
      Profile2?.country != Profile.country ||
      Profile2?.city != Profile.city ||
      Profile2?.address != Profile.address ||
      Profile2?.industry_type != Profile?.industry_type ||
      Profile2?.experience != Profile.experience ||
      Profile2?.province != Profile.province ||
      Profile2?.zip != Profile.zip ||
      Profile2?.phone_number != Profile.phone_number ||
      Profile2?.website != Profile.website
    ) {
      hasChanges2 = true;
    }
    setchanged2(hasChanges2);

    let hasChanges5 = false;
    if (
      // warehouse
      Profile2?.warehouse?.name != Profile?.warehouse?.name ||
      Profile2?.warehouse?.country != Profile?.warehouse?.country ||
      Profile2?.warehouse?.state != Profile?.warehouse?.state ||
      Profile2?.warehouse?.city != Profile?.warehouse?.city ||
      Profile2?.warehouse?.address != Profile?.warehouse?.address ||
      Profile2?.warehouse?.postcode != Profile?.warehouse?.postcode
    ) {
      hasChanges5 = true;
    }
    setchanged5(hasChanges5);

    // section 3
    let hasChanges3 = false;

    if (old_password != "" || new_password != "" || con_password != "") {
      hasChanges3 = true;
    } else {
      hasChanges3 = false;
    }
    setchanged3(hasChanges3);

    // section 1.1

    let hasChanges4 = false;
    if (file != null) {
      hasChanges4 = true;
    }
    setchanged4(hasChanges4);
  }, [Profile, user, old_password, new_password, con_password, file]);

  return (
    <>
      <Container>
        <div className="bg-ui-surface shadow  profile__main_wrap">
          {skeletonLoading ? (
            <Skeleton
              variant="rectangular"
              width="100%"
              height={210}
              style={{ marginTop: "40px" }}
            />
          ) : (
            <>
              <div className="profile__edit_content_wrap">
                <div className="profile__image_block">
                  <Avatar
                    name={
                      Profile
                        ? Profile["firstname"] + " " + Profile["lastname"]
                        : ""
                    }
                    size="150"
                    round="50%"
                    src={Profile ? Profile["profile_image"] : ""}
                    color="var(--color-brand)"
                    className="shadow"
                  />
                  <Button
                    variant="light"
                    className="image__icon_upload"
                    onClick={() => {
                      setimage(true);
                    }}
                  >
                    <BsPencil />
                  </Button>
                </div>

                <div className="profile__data_edit">
                  <h3>{t("profile.title")}</h3>
                  <small>
                    {t("profile.subtitle")}
                  </small>

                  <div className="form__profile_field_wrap">
                    <div className="fieldset__list_col">
                      <Form.Label>{t("profile.accountType")}</Form.Label>

                      <div className="label_background">
                        {Profile?.role
                          ? t(`profile.roles.${Profile.role}`, {
                              defaultValue: Profile.role,
                            })
                          : ""}
                      </div>
                    </div>
                    <div className="fieldset__list_col">
                      <Form.Label>{t("fields.username")}</Form.Label>
                      <div className="label_background">
                        {Profile ? Profile["username"] : ""}
                      </div>
                    </div>
                    <div className="fieldset__list_col">
                      <Form.Label>{t("fields.email")}</Form.Label>
                      <div className="label_background">
                        {Profile ? Profile["email"] : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {skeletonLoading ? (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={210}
            style={{ marginTop: "40px" }}
          />
        ) : (
          <div className="additional_info_wrap bg-ui-surface shadow">
            <h3>{t("profile.additionalTitle")}</h3>
            <small>
              {t("profile.privateHint")}
              {showAdditionalInfo ? (
                ""
              ) : (
                <div
                  className="additional_info_list_edit_btn"
                  onClick={additionalInfoListClick}
                >
                  <BsPencil />
                </div>
              )}
            </small>

            {showAdditionalInfo ? (
              <div className="additional_info_list_edit">
                <Form onSubmit={handleadditionalinfo}>
                  <div>
                    <div className="additional_info_list_edit_form">
                      <div className="field__main_additional_info">
                        <Form.Label>{t("fields.firstName")}</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={Profile ? Profile["firstname"] : ""}
                          name="firstname"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                      <div className="field__main_additional_info">
                        <Form.Label>{t("fields.lastName")}</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={Profile ? Profile["lastname"] : ""}
                          name="lastname"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                      <div className="field__main_additional_info">
                        <Form.Label>{t("profile.businessName")}</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={Profile ? Profile["business_name"] : ""}
                          name="business_name"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="additional_info_list_edit_form">
                      <div className="field__main_additional_info address_feild">
                        <Form.Label>{t("fields.address")}</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={Profile ? Profile["address"] : ""}
                          name="address"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="additional_info_list_edit_form">
                      <div className="field__main_additional_info">
                        <Form.Label>{t("fields.country")}</Form.Label>
                        <Form.Select
                          aria-label={t("profile.countrySelect")}
                          value={Profile["country"]}
                          name="country"
                          onChange={(e) => handleChange(e)}
                        >
                          {Countries.map((c) => {
                            return (
                              <option value={c?.code} key={c?.code}>
                                {formatCountry(c?.code, c?.name)}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </div>
                      <div className="field__main_additional_info">
                        <Form.Label>{t("fields.province")}</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={Profile ? Profile["province"] : ""}
                          name="province"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>

                      <div className="field__main_additional_info">
                        <Form.Label>{t("fields.city")}</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={Profile ? Profile["city"] : ""}
                          name="city"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                      <div className="field__main_additional_info">
                        <Form.Label>{t("profile.zip")}</Form.Label>
                        <Form.Control
                          type="text"
                          required
                          value={Profile ? Profile["zip"] : ""}
                          name="zip"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="additional_info_list_edit_form">
                      {Profile["role"] === "Carrier" ? (
                        <div className="field__main_additional_info">
                          <Form.Label>{t("profile.industryExperience")}</Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={Profile ? Profile["experience"] : ""}
                            name="experience"
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      ) : (
                        <div className="field__main_additional_info">
                          <Form.Label>{t("fields.industryType")}</Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={Profile ? Profile["industry_type"] : ""}
                            name="industry_type"
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      )}

                      <div className="field__main_additional_info">
                        <Form.Label>{t("fields.phoneNumber")}</Form.Label>
                        <Form.Control
                          type="phone"
                          required
                          value={Profile ? Profile["phone_number"] : ""}
                          name="phone_number"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>

                      <div className="field__main_additional_info">
                        <Form.Label>{t("profile.website")}</Form.Label>
                        <Form.Control
                          type="website"
                          required
                          value={Profile ? Profile["website"] : ""}
                          name="website"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="field__main_additional_info_footer_submit">
                    <Button
                      className="btn__cancle_wrap "
                      onClick={() => {
                        additionalInfoListClick();
                        setProfile({ ...Profile2 });
                      }}
                    >
                      {t("common:actions.back")}
                    </Button>

                    {changed2 && (
                      <Button
                        disabled={loading}
                        id="additional"
                        type="submit"
                        className="profile_buttons"
                      >
                        {loading === "additionalInfo" ? <Loader /> : t("common:actions.save")}
                      </Button>
                    )}
                  </div>
                </Form>
              </div>
            ) : (
              <div className="">
                <div className="additonal_info_list_view">
                  <div className="additonal_info_list_item">
                    <div className="additonal_info_list_item_label">
                      {t("fields.firstName")}
                    </div>
                    <div className="additonal_info_list_item_data">
                      {Profile["firstname"] ? Profile["firstname"] : "-"}
                    </div>
                  </div>
                  <div className="additonal_info_list_item">
                    <div className="additonal_info_list_item_label">
                      {t("fields.lastName")}
                    </div>
                    <div className="additonal_info_list_item_data">
                      {Profile["lastname"] ? Profile["lastname"] : "-"}
                    </div>
                  </div>
                  <div className="additonal_info_list_item">
                    <div className="additonal_info_list_item_label">
                      {t("profile.businessName")}
                    </div>
                    <div className="additonal_info_list_item_data">
                      {Profile["business_name"]
                        ? Profile["business_name"]
                        : "-"}
                    </div>
                  </div>
                </div>
                <div className="additonal_info_list_view">
                  <div className="additonal_info_list_item additonal_info_list_item_address">
                    <div className="additonal_info_list_item_label">
                      {t("fields.address")}
                    </div>
                    <div className="additonal_info_list_item_data">
                      {Profile["address"] ? Profile["address"] : " - "}
                    </div>
                  </div>
                </div>
                <div className="additonal_info_list_view">
                  <div className="additonal_info_list_item">
                    <div className="additonal_info_list_item_label">
                      {t("fields.country")}
                    </div>
                    <div className="additonal_info_list_item_data">
                      {Profile["country"]
                        ? formatCountry(
                            Profile["country"],
                            Countries?.find((c) => c.code === Profile["country"])
                              ?.name,
                          )
                        : "-"}
                    </div>
                  </div>
                  <div className="additonal_info_list_item">
                    <div className="additonal_info_list_item_label">
                      {t("fields.province")}
                    </div>
                    <div className="additonal_info_list_item_data">
                      {Profile["province"] ? Profile["province"] : " - "}
                    </div>
                  </div>
                  <div className="additonal_info_list_item">
                    <div className="additonal_info_list_item_label">{t("fields.city")}</div>
                    <div className="additonal_info_list_item_data">
                      {Profile["city"] ? Profile["city"] : " - "}
                    </div>
                  </div>
                  <div className="additonal_info_list_item">
                    <div className="additonal_info_list_item_label">{t("profile.zip")}</div>
                    <div className="additonal_info_list_item_data">
                      {Profile["zip"] ? Profile["zip"] : " - "}
                    </div>
                  </div>
                </div>
                <div className="additonal_info_list_view">
                  {Profile["role"] === "Carrier" ? (
                    <div className="additonal_info_list_item">
                      <div
                        className="additonal_info_list_item_label"
                        style={{ maxWidth: "160px" }}
                      >
                        {t("profile.industryExperience")}
                      </div>
                      <div className="additonal_info_list_item_data">
                        {Profile["experience"] ? Profile["experience"] : " - "}
                      </div>
                    </div>
                  ) : (
                    <div className="additonal_info_list_item">
                      <div className="additonal_info_list_item_label">
                        {t("fields.industryType")}
                      </div>
                      <div className="additonal_info_list_item_data">
                        {Profile["industry_type"]
                          ? Profile["industry_type"]
                          : " - "}
                      </div>
                    </div>
                  )}

                  <div className="additonal_info_list_item">
                    <div className="additonal_info_list_item_label">
                      {t("fields.phoneNumber")}
                    </div>
                    <div className="additonal_info_list_item_data">
                      {Profile["phone_number"]
                        ? Profile["phone_number"]
                        : " - "}
                    </div>
                  </div>

                  <div className="additonal_info_list_item">
                    <div className="additonal_info_list_item_label">
                      {t("profile.website")}
                    </div>
                    <div className="additonal_info_list_item_data">
                      {Profile["website"] ? (
                        <a
                          href={
                            Profile?.website.startsWith("http")
                              ? Profile?.website
                              : `http://${Profile?.website}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {Profile["website"]}
                        </a>
                      ) : (
                        t("profile.notAvailable")
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {Profile?.role === "warehouseUser" && (
          <>
            {skeletonLoading ? (
              <Skeleton
                variant="rectangular"
                width="100%"
                height={210}
                style={{ marginTop: "40px" }}
              />
            ) : (
              <div className="additional_info_wrap bg-ui-surface shadow">
                <h3>{t("profile.warehouseTitle")}</h3>
                <small>
                  {t("profile.privateHint")}
                  {showAdditionalWarehouseInfo ? (
                    ""
                  ) : (
                    <div
                      className="additional_info_list_edit_btn"
                      onClick={additionalWarehouseInfoListClick}
                    >
                      <BsPencil />
                    </div>
                  )}
                </small>

                {showAdditionalWarehouseInfo ? (
                  <div className="additional_info_list_edit">
                    <Form onSubmit={handleWarehouseInfo}>
                      <div className="additional_info_list_edit_form">
                        <div className="field__main_additional_info">
                          <Form.Label>{t("fields.name")}</Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={Profile ? Profile?.warehouse?.["name"] : ""}
                            name="name"
                            onChange={(e) => handleChangeForWarehouse(e)}
                          />
                        </div>
                      </div>
                      <div className="additional_info_list_edit_form">
                        <div className="field__main_additional_info address_feild">
                          <Form.Label>{t("fields.address")}</Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={Profile ? Profile?.warehouse?.["address"] : ""}
                            name="address"
                            onChange={(e) => handleChangeForWarehouse(e)}
                          />
                        </div>
                      </div>
                      <div className="additional_info_list_edit_form">
                        <div className="field__main_additional_info">
                          <Form.Label>{t("fields.country")}</Form.Label>
                          <Form.Select
                            aria-label={t("profile.countrySelect")}
                            value={Profile?.warehouse?.["country"]}
                            name="country"
                            onChange={(e) => handleChangeForWarehouse(e)}
                          >
                            {Countries.map((c) => {
                              return (
                                <option value={c?.code} key={c?.code}>
                                  {formatCountry(c?.code, c?.name)}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </div>
                        <div className="field__main_additional_info">
                          <Form.Label>{t("fields.province")}</Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={Profile ? Profile?.warehouse?.["state"] : ""}
                            name="state"
                            onChange={(e) => handleChangeForWarehouse(e)}
                          />
                        </div>
                        <div className="field__main_additional_info">
                          <Form.Label>{t("fields.city")}</Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={Profile ? Profile?.warehouse?.["city"] : ""}
                            name="city"
                            onChange={(e) => handleChangeForWarehouse(e)}
                          />
                        </div>

                        <div className="field__main_additional_info">
                          <Form.Label>{t("profile.zip")}</Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={
                              Profile ? Profile?.warehouse?.["postcode"] : ""
                            }
                            name="postcode"
                            onChange={(e) => handleChangeForWarehouse(e)}
                          />
                        </div>
                      </div>

                      <div className="field__main_additional_info_footer_submit">
                        <Button
                          className="btn__cancle_wrap "
                          onClick={() => {
                            additionalWarehouseInfoListClick();
                            setProfile({ ...Profile2 });
                          }}
                        >
                          {t("common:actions.back")}
                        </Button>

                        {changed5 && (
                          <Button
                            disabled={loading}
                            id="additional"
                            type="submit"
                            className="profile_buttons"
                          >
                            {loading === "warehouseInfo" ? <Loader /> : t("common:actions.save")}
                          </Button>
                        )}
                      </div>
                    </Form>
                  </div>
                ) : (
                  <div className="">
                    <div className="additonal_info_list_view">
                      <div className="additonal_info_list_item">
                        <div className="additonal_info_list_item_label">
                          {t("fields.code")}
                        </div>
                        <div className="additonal_info_list_item_data">
                          {Profile?.warehouse?.["code"]
                            ? Profile?.warehouse?.["code"]
                            : "-"}
                        </div>
                      </div>
                      <div className="additonal_info_list_item">
                        <div className="additonal_info_list_item_label">
                          {t("fields.name")}
                        </div>
                        <div className="additonal_info_list_item_data">
                          {Profile?.warehouse?.["name"]
                            ? Profile?.warehouse?.["name"]
                            : "-"}
                        </div>
                      </div>
                    </div>

                    <div className="additonal_info_list_view">
                      <div className="additonal_info_list_item additonal_info_list_item_address">
                        <div className="additonal_info_list_item_label">
                          {t("fields.address")}
                        </div>
                        <div className="additonal_info_list_item_data">
                          {Profile?.warehouse?.["address"]
                            ? Profile?.warehouse?.["address"]
                            : "-"}
                        </div>
                      </div>
                    </div>

                    <div className="additonal_info_list_view">
                      <div className="additonal_info_list_item">
                        <div className="additonal_info_list_item_label">
                          {t("fields.country")}
                        </div>
                        <div className="additonal_info_list_item_data">
                          {Profile?.warehouse?.["country"]
                            ? formatCountry(
                                Profile?.warehouse?.["country"],
                                Countries?.find(
                                  (c) => c.code === Profile?.warehouse?.["country"]
                                )?.name,
                              )
                            : "-"}
                        </div>
                      </div>
                      <div className="additonal_info_list_item">
                        <div className="additonal_info_list_item_label">
                          {t("fields.province")}
                        </div>
                        <div className="additonal_info_list_item_data">
                          {Profile?.warehouse?.["state"]
                            ? Profile?.warehouse?.["state"]
                            : "-"}
                        </div>
                      </div>
                      <div className="additonal_info_list_item">
                        <div className="additonal_info_list_item_label">
                          {t("fields.city")}
                        </div>
                        <div className="additonal_info_list_item_data">
                          {Profile?.warehouse?.["city"]
                            ? Profile?.warehouse?.["city"]
                            : "-"}
                        </div>
                      </div>
                      <div className="additonal_info_list_item">
                        <div className="additonal_info_list_item_label">
                          {t("profile.zip")}
                        </div>
                        <div className="additonal_info_list_item_data">
                          {Profile?.warehouse?.["postcode"]
                            ? Profile?.warehouse?.["postcode"]
                            : "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}

        {skeletonLoading ? (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={210}
            style={{ marginTop: "40px" }}
          />
        ) : (
          <div className="bg-ui-surface shadow password__sec_wrap">
            <h3>{t("profile.passwordTitle")}</h3>
            <small>
              {t("profile.passwordHint")}
              {showPasswordFields ? (
                ""
              ) : (
                <div className="password_editable" onClick={handlePasswordEdit}>
                  <BsPencil />
                </div>
              )}
            </small>

            {showPasswordFields ? (
              <Form className="passwor__edit_wrap" onSubmit={handlepassword}>
                <div
                  className="additonal_info_list_item"
                  style={{ flexDirection: "column" }}
                >
                  <Form.Label>{t("profile.currentPassword")}</Form.Label>
                  <Form.Control
                    type="password"
                    required
                    value={old_password}
                    name="old_password"
                    onChange={(e) => handleoldpassword(e)}
                  />
                </div>

                <div
                  className="additonal_info_list_item"
                  style={{ flexDirection: "column" }}
                >
                  <Form.Label>{t("fields.newPassword")}</Form.Label>
                  <Form.Control
                    type="password"
                    required
                    value={new_password}
                    name="new_password"
                    onChange={(e) => handlenewpassword(e)}
                  />
                </div>
                <div
                  className="additonal_info_list_item"
                  style={{ flexDirection: "column" }}
                >
                  {/* <div> */}
                  <Form.Label>{t("fields.confirmPassword")}</Form.Label>
                  <Form.Control
                    type="password"
                    value={con_password}
                    name="con_password"
                    onChange={(e) => handleconpassword(e)}
                    isInvalid={
                      con_password != "" && con_password != new_password
                        ? true
                        : false
                    }
                  />
                  {/* </div> */}
                  {con_password != "" && con_password != new_password && (
                    <small style={{ color: "red" }}>
                      {t("profile.passwordMismatch")}
                    </small>
                  )}
                </div>
                <div className="additonal_info_list_item">
                  <Button
                    className="btn__cancle_wrap"
                    onClick={() => {
                      handlePasswordEdit();
                      setcon_password("");
                      setnew_password("");
                      setold_password("");
                    }}
                  >
                    {t("common:actions.back")}
                  </Button>

                  {changed3 && (
                    <>
                      <Button
                        id="additional"
                        type="submit"
                        disabled={con_password != new_password || loading}
                        className="profile_buttons"
                      >
                        {loading === "updatepassword" ? <Loader /> : t("common:actions.save")}
                      </Button>
                    </>
                  )}
                </div>
              </Form>
            ) : (
              <div className="password__display_text">
                <div className="additonal_info_list_item_label">{t("fields.password")}</div>
                <div className="additonal_info_list_item_data">
                  ***************
                </div>
              </div>
            )}
          </div>
        )}
      </Container>
      <Modal
        show={image}
        onHide={() => {
          setimage(false);
          setfile(null);
        }}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("profile.editImage")}</Modal.Title>
        </Modal.Header>
        <form>
          <Modal.Body className="m-2">
            <Avatar
              name={
                Profile ? Profile["firstname"] + " " + Profile["lastname"] : ""
              }
              size="150"
              round="50%"
              src={
                file ? URL.createObjectURL(file) : `${Profile["profile_image"]}`
              }
              color="var(--color-brand)"
              className="shadow"
            />
            <Form.Group controlId="formFile" className="mb-3 mt-3 col-6">
              <Form.Label>{t("profile.uploadImage")}</Form.Label>
              <Form.Control type="file" size="sm" onChange={handleprofileimg} />
            </Form.Group>
            {changed4 && (
              <Button
                disabled={loading}
                className="mb-3 col-3 profile_buttons"
                onClick={handleimageupdate}
                style={{ minWidth: "70px" }}
              >
                {loading === "image" ? <Loader /> : t("common:actions.save")}
              </Button>
            )}
          </Modal.Body>
        </form>
      </Modal>
    </>
  );
};

export default Profile;
